module.exports = __webpack_public_path__ + "static/___000___Phuket’s-most-desired-residential-community.d264eec5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/___000___Phuket’s-most-desired-residential-community.jpg
// module id = 1276
// module chunks = 64098118039141